import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { dailyActivityAPI } from '../../services/api'
import { BoltIcon } from '@heroicons/react/24/outline'

export default function ActivitySummaryCard({ onNavigate }) {
  const { t } = useTranslation()

  const { data: latestActivity, isLoading } = useQuery({
    queryKey: ['latestActivity'],
    queryFn: () => dailyActivityAPI.getLatest(),
    select: (response) => response.data?.log
  })

  if (isLoading) {
    return (
      <div className="bg-surface-container border rounded-lg p-4 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-3" />
        <div className="h-8 bg-gray-200 rounded w-3/4" />
      </div>
    )
  }

  const hasData = latestActivity && (latestActivity.steps || latestActivity.calories_burned)

  return (
    <button
      onClick={() => onNavigate?.('activity')}
      className="bg-surface-container border rounded-lg p-4 text-left hover:border-blue-300 hover:shadow-sm transition-all w-full"
    >
      <div className="flex items-center mb-3">
        <BoltIcon className="h-5 w-5 text-blue-600 mr-2" />
        <h4 className="text-sm font-medium text-gray-700">
          {t('myProgress.activitySummary', 'Activity')}
        </h4>
      </div>
      {hasData ? (
        <div className="space-y-1.5">
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">{t('activity.steps', 'Steps')}</span>
            <span className="text-sm font-semibold text-gray-900">
              {latestActivity.steps?.toLocaleString() || '-'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">{t('activity.caloriesBurned', 'Burned')}</span>
            <span className="text-sm font-semibold text-gray-900">
              {latestActivity.calories_burned?.toLocaleString() || '-'} kcal
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">{t('activity.activeMinutes', 'Active')}</span>
            <span className="text-sm font-semibold text-gray-900">
              {latestActivity.active_minutes || '-'} min
            </span>
          </div>
        </div>
      ) : (
        <p className="text-sm text-gray-400">{t('common.noData', 'No data')}</p>
      )}
    </button>
  )
}
